import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, CardBody, Card, CardHeader, Row } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import AddEditFeedingSiloModal from './Add_Edit/AddEditFeedingSilo';
import DeleteFeedingSiloModal from './Delete/DeleteFeedingSilo';
import { getFeedingSiloList } from '../../../slices/feedingSilo/thunk';

const FeedingSiloList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorFeedingSilo = createSelector(
		state => state.FeedingSilo,
		data => ({
			feedingSiloList: data.feedingSiloList,
			isLoadingList: data.isLoadingList,
			isFeedingSiloSuccess: data.isFeedingSiloSuccess,
			error: data.error,
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isAddError: data.isAddError,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isUpdateError: data.isUpdateError,
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
		})
	);

	const { feedingSiloList, isLoadingList } = useSelector(selectorFeedingSilo);

	useEffect(() => {
		dispatch(getFeedingSiloList());
	}, []);

	
	const [dataFeedingSilo, setDataFeedingSilo] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete FeedingSilo
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = feedingSilo => {
		setDataFeedingSilo(feedingSilo);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = feedingSilo => {
		setDataFeedingSilo(feedingSilo);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'feedingSilo',
				columnDefType: 'display',
				 size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const feedingSiloData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(feedingSiloData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const feedingSiloData =
														cellProps.row.original;
													handleClickDelete(feedingSiloData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},

			{ header: 'Nombre', accessorKey: 'name', },
			{ header: 'Artefacto Naval', accessorKey: 'feeding_barges.name', },
			{ header: 'Capacidad', accessorKey: 'capacity', },
			{ header: 'Saldo', accessorKey: 'stock', },
			{ header: 'Alimento', accessorKey: 'material', },
			{ header: 'Descripción', accessorKey: 'description', },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataFeedingSilo({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Silo de Alimento
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={feedingSiloList || []}
								isLoadingData={isLoadingList}
								nameFile={'silo_de_alimento'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataFeedingSilo({});
											handleToggleModal();
										},
										title: 'Crear Silo de Alimento',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditFeedingSiloModal
				dataFeedingSilo={dataFeedingSilo}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteFeedingSiloModal
				dataFeedingSilo={dataFeedingSilo}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default FeedingSiloList;
